import { KnowledgeContent, EmergencyContent } from '../models';
import { getRequest } from './httpService';

export const searchContentsByKeyword = async (keyword: string, categories?: string[]): Promise<KnowledgeContent[]> => {
  try {
    let searchQuery = `keyword=${keyword}`;
    if (categories) {
      categories.push('au');
      categories.push('uq');
      categories.push('故障かも');
      const categoriesQuery = categories.reduce((query, category) => {
        return `${query}&categories=${category}`;
      }, '');

      searchQuery += categoriesQuery;
    }

    const contents = await getRequest(`${process.env.VUE_APP_API_DOMAIN}/api/content/faq/search?${searchQuery}`) as KnowledgeContent[];
    return contents;
  } catch (error) {
    // return empty contents if error
    return [];
  }
};

export const getEmergencyContents = async (): Promise<EmergencyContent[]> => {
  const emergencyContents = await getRequest(`${process.env.VUE_APP_API_DOMAIN}/api/content/emergency/search?sortKeys=postModifiedDESC`) as EmergencyContent[];
  return emergencyContents;
};

export const searchContentByCategoryId = async (categoryId: string): Promise<KnowledgeContent> => {
  const content = await getRequest(`${process.env.VUE_APP_API_DOMAIN}/content/${categoryId}`) as KnowledgeContent;

  return content;
};

export const searchContentByContentId = async (contentID: string): Promise<KnowledgeContent> => {
  const content = await getRequest(`${process.env.VUE_APP_API_DOMAIN}/api/content/search/${contentID}`) as KnowledgeContent;
  return content;
};

export const searchTimelineContentByString = async (keyword: string): Promise<KnowledgeContent[]> => {
  try {
    const searchQuery = `keyword=${keyword}`;
    const contents = await getRequest(`${process.env.VUE_APP_API_DOMAIN}/api/content/search?type=timeline&${searchQuery}`) as KnowledgeContent[];
    return contents;
  } catch (error) {
    return [];
  }
};
